import { ProductCard } from "../../components";
import Image from "next/image";
import React, { useState } from "react";
import Slider from "react-slick";
import styles from "../../styles/RelatedProducts.module.css";
import {
  chevronLeft,
  chevronRight,
  SliderLeft,
  SliderRight,
} from "../../../public/icons";
import { Button, Card, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { location } from "../../../public/icons/index";
import { motion } from "framer-motion";
import { useRouter } from "next/navigation";
import LoadingCard from "../../components/LoadingCard";
import ContactSellerModal from "../../components/ContactSellerModal";
import { useUserStore } from "../../store/User";
import WishlistIcon from "../../components/WishlistIcon";
import imagePlaceholder from "../../../public/images/imagePlaceholder.png";

import Link from "next/link";
import { replaceSpecialCharacters } from "../../utility/Images/utils";
import { marketplaceCdn } from "../../utility/env";
import { listing_visit, Phone_BtnClick } from "../../UserEvents/UserEvents";
import { trackContact, trackListingVisit } from "../../utility/UserEvents";
import { LeadType } from "../../Constants/userEventEnums";

const ViewList = ({ relatedProducts, paramId }: any) => {
  const [sliderRef, setSliderRef] = useState<any>(null);

  const settings = {
    className: "center",

    // centerMode: true,
    arrows: false,
    centerPadding: "10px",
    slidesToShow: relatedProducts?.length > 3 ? 4 : relatedProducts?.length,
    swipeToSlide: true,
    variableWidth: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1824,
        settings: {
          slidesToShow:
            relatedProducts?.length > 3 ? 3 : relatedProducts?.length,
          slidesToScroll: 1,

          dots: false,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 1490,
        settings: {
          // centerMode: true,
          slidesToShow:
            relatedProducts?.length > 3 ? 3 : relatedProducts?.length,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
        },
      },

      {
        breakpoint: 1024,
        settings: {
          // centerMode: true,
          slidesToShow:
            relatedProducts?.length > 3 ? 3 : relatedProducts?.length,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
        },
      },
      {
        breakpoint: 868,
        settings: {
          slidesToShow:
            relatedProducts?.length > 2 ? 2 : relatedProducts?.length,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow:
            relatedProducts?.length > 2 ? 2 : relatedProducts?.length,
          centerMode: true,
          dots: false,
          slidesToScroll: 1,
        },
      },
    ],
    afterChange: function (index: any) {
      `Slider Changed to: ${index + 1}, background: #222; color: #bada55`;
    },
  };

  return (
    <div className={styles.related_div}>
      <div className="">
        <div className="text-center mb-1">
          <div className={styles.re_paragraph_div}>
            <h1 className={` ${styles.re_h1} `}> Recently Viewed</h1>

            {relatedProducts.length >= 3 ? (
              <>
                <div
                  className={` ${styles.arrows} cursor-pointer d-lg-flex d-none me-4 d-flex align-items-center`}
                >
                  <div
                    onClick={sliderRef?.slickPrev}
                    className={`${styles.favarrow} mb-1 py-1 rounded-2 px-2 mx-2 `}
                  >
                    <Image
                      className=" mb-1"
                      src={chevronLeft}
                      alt="chevronleft"
                    />
                  </div>
                  <div
                    onClick={sliderRef?.slickNext}
                    className={`${styles.favarrow} mb-1 py-1 rounded-2 px-2 `}
                  >
                    <Image
                      className="mb-1"
                      src={chevronRight}
                      alt="chevronright"
                    />
                  </div>
                </div>
              </>
            ) : (
              <div
                className={` ${styles.arrows} d-lg-flex d-none me-4 d-flex align-items-center`}
              ></div>
            )}
            {/* {relatedProducts.length >= 3 && (
              <div
                className={`${styles.slider_arrow} d-lg-none d-flex justify-content-between`}
              >
                <div className={`${styles.arrow_btn_div}`}>
                  <Button
                    onClick={sliderRef?.slickPrev}
                    className={`${styles.arrow_btn_btn}`}
                  >
                    <Image src={SliderLeft} alt="sliderleft" />
                  </Button>
                </div>
                <div className={`${styles.arrow_btn_div_right}`}>
                  <Button
                    onClick={sliderRef?.slickNext}
                    className={`${styles.arrow_btn_btn}`}
                  >
                    <Image src={SliderRight} alt="sliderright" />
                  </Button>
                </div>
              </div>
            )} */}
          </div>
        </div>
        <div className="position-relative">
          {/* Arrows positioned absolutely over the slider */}
          {relatedProducts.length >= 3 && (
            <div
              className={`${styles.slider_arrow} d-lg-none d-flex justify-content-between position-absolute w-100`}
              style={{ top: "50%", transform: "translateY(-50%)", zIndex: 1 }}
            >
              <div className={styles.arrow_btn_div}>
                <Button
                  onClick={sliderRef?.slickPrev}
                  className={styles.arrow_btn_btn}
                >
                  <Image src={SliderLeft} alt="sliderleft" />
                </Button>
              </div>
              <div className={styles.arrow_btn_div_right}>
                <Button
                  onClick={sliderRef?.slickNext}
                  className={styles.arrow_btn_btn}
                >
                  <Image src={SliderRight} alt="sliderright" />
                </Button>
              </div>
            </div>)}

          {/* Slider itself */}
          <Slider ref={setSliderRef} {...settings}>
            {relatedProducts?.map((item: any, index: number) => (
              <div key={index}>
                {Number(item.listing_id) !== Number(paramId) && (
                  <RelatedProductCard
                    item={item}
                    id={item.listing_id}
                    discount={item.online_discount}
                    discountUnit={item.online_discount_unit}
                    price={item.online_price}
                    image={item.item.itemImages[0]}
                    title={item.listing_title}
                    effectivePrice={item?.effective_price}
                  />
                )}
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

interface productProp {
  recomended?: boolean;
  loading?: Boolean;
  image: any;
  title: string;
  price: number;
  discount: number;
  discountUnit: string;
  id: number;
  item: any;
  effectivePrice: number;
}

interface heightType {
  height: {
    delay: number;
    duration: number;
  };
}

const RelatedProductCard: React.FC<productProp> = ({
  recomended,
  price,
  item,
  loading,
  image,
  title,
  discount,
  discountUnit,
  id,
  effectivePrice,
}) => {
  const [contactModal, setContactModal] = useState(false);
  const shopDetails = item?.item?.shopTable;
  const locations = item?.item?.location;
  const city = item?.item?.location?.city?.city_name;
  const [isLiked, setIsLiked] = useState(false);
  const { user, token } = useUserStore((state: any) => state);

  const handleLikeClick = () => {
    setIsLiked(!isLiked);
  };

  const router = useRouter();
  const calculatePrice = (price: any, discount: any, discountUnit: any) => {
    if (discountUnit === "percentage") {
      return price - price * (discount / 100);
    } else if (discountUnit === "fixed") {
      return price - discount;
    }
  };
  
  return (
    <>
      <Col className="mt-4 px-2" lg="4" md="4" sm="6" xs="8">
        {loading ? (
          <LoadingCard />
        ) : (
          <Card
            className={` ${recomended ? "" : " "} cursor-pointer`}
            style={
              recomended
                ? {
                    width: "17.7rem",
                    border: " 1px solid #D8E4F8",
                    margin: "0",
                  }
                : {
                    width: "15.3rem",
                    border: " 1px solid #D8E4F8",
                    margin: "0",
                  }
            }
            // onClick={() => router.push("/productDetails/Samsung")}
          >
            <div className="card-container position-relative  ">
              <div className="row p-0 mx-0 ">
                <div
                  className="position-relative"
                  id="card-img-container"
                  style={{ height: "96px", maxHeight: "124px" }}
                >
                  <Link
                    onClick={() => {
                      trackListingVisit(
                        id,
                        user?.uuid,
                        "DPDP",
                        title,
                        `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/products/${replaceSpecialCharacters(
                          title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "")
                            .replaceAll("--", "")
                        ).trim()}-${id}`
                      );
                    }}
                    href={`/products/${replaceSpecialCharacters(
                      title
                        ?.replaceAll(" ", "-")
                        ?.replaceAll("/", "")
                        ?.replaceAll("--", "")
                    )}-${id}`}
                  >
                    <motion.img
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.3, duration: 0.4 }}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        aspectRatio: "16/9",
                      }}
                      className="p-0"
                      src={`${marketplaceCdn}/${image}`}
                      alt="productImg"
                      onError={(e: any) =>
                        (e.target.src = `${imagePlaceholder.src}`)
                      }
                      // onClick={() => router.push(`/products/${title.replaceAll(" ", "-").replaceAll("/", "--")}-${listingId}`)}
                    />
                  </Link>
                  <div className="rounded-circle text-center position-absolute bottom-0 end-0  m-0 p-0">
                    <WishlistIcon
                      page="DPLP"
                      listingId={id}
                      title={title}
                      price={effectivePrice}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="  rounded-circle text-center position-absolute top-0 end-0 m-0 p-0">
                <WishlistIcon listingId={id} title={title} />
              </div> */}
              <div
                className={`text-center position-absolute top-0 start-0 d-flex justify-content-center align-items-center`}
                style={{
                  border: "1px 1px 1px 0 solid #D8E4F8",
                  borderTopLeftRadius: "7px",
                  borderBottomLeftRadius: "0",
                  borderBottomRightRadius: "7px",
                  background: "#D957F9B3",
                }}
              >
                <p
                  className="m-0 fs-9 py-1 fw-bold p-2 text-white"
                  style={{ fontSize: "0.7rem" }}
                >
                  {item?.item?.condition_item}
                </p>
              </div>
              <Link
                onClick={() => {
                  trackListingVisit(
                    id,
                    user?.uuid,
                    "DPLP",
                    title,
                    `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/products/${replaceSpecialCharacters(
                      title
                        .replaceAll(" ", "-")
                        .replaceAll("/", "")
                        .replaceAll("--", "")
                    ).trim()}-${id}`
                  );
                }}
                href={`/products/${replaceSpecialCharacters(
                  title
                    ?.replaceAll(" ", "-")
                    ?.replaceAll("/", "")
                    ?.replaceAll("--", "")
                )}-${id}`}
              >
                <Card.Body className="px-2 py-1 mt-0">
                  <div
                    className="row align-items-start product-title-row"
                    style={{ height: "3rem" }}
                  >
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip">{title}</Tooltip>}
                    >
                      <p className={`${styles.product_title} `}>{title}</p>
                    </OverlayTrigger>
                  </div>

                  {effectivePrice ? (
                    <div
                      className="d-flex flex-row m-0 p-0 flex-wrap"
                      style={{ height: "1.5rem" }}
                    >
                      <p className="fw-bold m-0 me-2 fw-700 fs-16">
                        <span className="">Rs. </span>
                        {discount > 0
                          ? effectivePrice?.toLocaleString()
                          : price?.toLocaleString()}
                      </p>
                      <div className="text-decoration-line-through text-muted fw-500 fs-16">
                        {discount !== 0
                          ? `Rs. ${price?.toLocaleString()}`
                          : null}
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center mb-2">
                      <Button
                        variant="outline-secondary"
                        className=" btn-sm w-100 mx-2 rounded-3"
                        onClick={() => {
                          trackContact(
                            shopDetails.shop_id,
                            user ? user?.uuid : null,
                            LeadType.PHONE,
                            item?.location?.location_number
                          );
                          window.open(
                            `tel: ${
                              shopDetails.on_payment
                                ? item?.location?.location_number
                                : "+923104447724"
                                    .replace("+92", 92)
                                    .replaceAll("-", "")
                            }`,
                            "_self"
                          );
                        }}
                      >
                        Call for Price
                      </Button>
                    </div>
                  )}
                </Card.Body>
              </Link>
            </div>
          </Card>
        )}
      </Col>
      {/* <ContactSellerModal
        shopDetails={shopDetails}
        locations={locations}
        city={city}
        show={contactModal}
        onHide={() => setContactModal(false)}
      /> */}
    </>
  );
};

export { RelatedProductCard, ViewList };
